import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["userId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../constants/ActionTypes';
import common from '../_common/reducers';
import { DEFAULT_INITIAL_STATE } from '../_common/reducers';
export var INITIAL_STATE = _objectSpread(_objectSpread({}, DEFAULT_INITIAL_STATE), {}, {
  groups: _objectSpread({}, DEFAULT_INITIAL_STATE)
});

function update(state, action) {
  // eslint-disable-next-line no-unused-vars
  var _action$data = action.data,
      userId = _action$data.userId,
      data = _objectWithoutProperties(_action$data, _excluded);

  data.activeKey = action.data.userId;
  return _objectSpread(_objectSpread({}, state), data);
}

function loadRequest(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}

function loadRequestError(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.USERS.ADD:
      return common.add(state, action);

    case ActionTypes.USERS.INDEX.ADD:
      return common.addIndex(state, action);

    case ActionTypes.USERS.INDEX.CLEAR_ALL:
      return common.clearIndexes(state, action);

    case ActionTypes.USERS.USE.INDEXED.CLEAR:
      return common.useIndexedClear(state, action);

    case ActionTypes.USERS.USE.INDEXED.REGISTER:
      return common.registerUseIndexed(state, action);

    case ActionTypes.USERS.ADD_UNRECEIVED:
      return common.addUnreceivedKeys(state, action);

    case ActionTypes.USERS.SET_ACTIVE_KEY:
      return common.setActive(state, action);

    case ActionTypes.USERS.USE.KEYS.CLEAR:
      return common.useKeysClear(state, action);

    case ActionTypes.USERS.USE.KEYS.REGISTER:
      return common.useKeysRegister(state, action);

    case ActionTypes.COMMON.DATA.SET_OUTDATED:
      //set outdated for users and users.groups
      return _objectSpread(_objectSpread({}, common.dataSetOutdated(state, action)), {}, {
        groups: common.dataSetOutdated(state.groups, action)
      });

    case ActionTypes.COMMON.DATA.CLEANUP_ON_LOGOUT:
      //clear users and users.groups
      return _objectSpread(_objectSpread({}, common.cleanupOnLogout(state, action)), {}, {
        groups: common.cleanupOnLogout(state.groups, action)
      });

    case ActionTypes.USERS_LOAD_REQUEST:
      return loadRequest(state, action);

    case ActionTypes.USERS_LOAD_REQUEST_ERROR:
      return loadRequestError(state, action);

    case ActionTypes.USERS_UPDATE:
      return update(state, action);

    case ActionTypes.USERS.GROUPS.ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.add(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.INDEX.ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.addIndex(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.INDEX.CLEAR_ALL:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.clearIndexes(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.ADD_UNRECEIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.addUnreceivedKeys(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.USE.INDEXED.CLEAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.useIndexedClear(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.USE.KEYS.CLEAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.useKeysClear(state.groups, action)
      });

    case ActionTypes.USERS.GROUPS.USE.INDEXED.REGISTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: common.registerUseIndexed(state.groups, action)
      });

    default:
      return state;
  }
});